import { useSelector } from 'react-redux';

import { contactStatuses, contactStatusesTranslated } from '@/services/dictionaries/ContactStatuses';
import { getContactsCounts } from '@/store/contacts/actions';
import { useTranslation } from 'react-i18next';

export const useContactsAvailableStatuses = () => {
    const { t } = useTranslation();
    const contactsCounts = useSelector(getContactsCounts);

    const filterStatuses =
        !!contactsCounts &&
        contactStatuses.map((status): { value: string; label: string; count: number } => {
            const { translationKey, enumValue } = status;

            const labelText = contactStatusesTranslated.find((o) => o.enumValue === enumValue)?.translationKey;

            return {
                value: enumValue,
                label: t(labelText),
                count: contactsCounts?.[`${translationKey}Count`],
            };
        });

    return !!filterStatuses && filterStatuses.filter((status): boolean => status.count > 0);
};
